'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconMenu = function (_React$Component) {
  _inherits(IconMenu, _React$Component);

  function IconMenu() {
    _classCallCheck(this, IconMenu);

    return _possibleConstructorReturn(this, (IconMenu.__proto__ || Object.getPrototypeOf(IconMenu)).apply(this, arguments));
  }

  _createClass(IconMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['size', 'children']);

      return _react2.default.createElement(
        'svg',
        Object.assign({
          viewBox: '0 0 24 24',
          preserveAspectRatio: 'xMidYMid meet',
          fill: 'currentColor',
          width: size,
          height: size
        }, otherProps),
        _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' }),
        children
      );
    }
  }]);

  return IconMenu;
}(_react2.default.Component);

IconMenu.displayName = 'IconMenu';
IconMenu.propTypes = {
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  children: _propTypes2.default.node
};
IconMenu.defaultProps = {
  size: '1em'
};
exports.default = IconMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-icon/lib/IconMenu.js
// module id = 1086
// module chunks = 3